// import { registerVueComponent } from '/vodalys/vvuejs/vueRegister.mjs'
// import { Container, Draggable } from 'vue-smooth-dnd/dist/vue-smooth-dnd.esm.js'

// registerVueComponent('Container', Container)
// registerVueComponent('Draggable', Draggable)


import Vue from "/vodalys/vvuejs/vue";

import resize from "vue-element-resize-detector";

Vue.use(resize)